<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div
        class="bylaDiv mr-2"
        v-bind="attrs"
        v-on="on"
        :loading="loading"
        @click="showByla()"
      >
        <v-progress-circular
          v-if="loading"
          size="22"
          indeterminate
          color="primary"
          class="bylaProgress"
        ></v-progress-circular>
        <v-icon class="bylaIcon" :color="color" v-if="!loading && !noIcon">
          {{ bylaIcon }}
        </v-icon>
        <template v-if="withName">
          <div :class="bylaNameClass">
            {{ bylaIconTitle }}
          </div>
        </template>
      </div>
    </template>
    <span>{{ bylaTitle }} </span>
  </v-tooltip>
</template>

<script>
import math from '../../mixins/math'
import notKurejas from '../../mixins/notKurejas'
import bylaName from '../../mixins/bylaName'

export default {
  name: 'ElByla',
  mixins: [math, bylaName, notKurejas],
  props: {
    byla: Object,
    color: { type: String, default: 'default' },
    withName: { type: Boolean, default: false },
    inLine: { type: Boolean, default: false },
    noIcon: { type: Boolean, default: false },
    longName: { type: Boolean, default: false },
    modalName: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    bylaNameClass() {
      return `bylaName ${this.inLine ? 'bylaNameLine' : ''} ${
        this.noIcon ? 'noIcon' : ''
      } text-truncate ${this.longName ? 'bylaNameLong' : ''} ${
        this.modalName ? 'bylaNameModal' : ''
      }`
    },
  },
  methods: {
    showByla() {
      if (this.loading) {
        return
      }
      if (this.byla.notKurejas) {
        this.notKurejas()
      } else {
        this.loading = true
        this.$axios
          .get(this.byla.byl_url, {
            responseType: 'arraybuffer',
          })
          .then(res => {
            this.openFile(res.data)
            this.$emit('openFile')
          })
          .catch(err => {
            const errData = JSON.parse(
              Buffer.from(err.response.data).toString('utf8')
            )
            window._VMA.$emit('DATA_ERROR', errData.message)
          })
          .finally(() => {
            this.loading = false
            this.$emit('bylaOpen', this.byla)
          })
      }
    },
    openFile(fileData) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute('download', this.safeFileName(this.bylaName))
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.bylaDiv {
  cursor: pointer;
  display: inline-flex;
  white-space: nowrap;
  align-items: flex-start;
}
.bylaProgress {
  margin-top: 4px;
  margin-right: 2px;
  line-height: 24px;
}
.bylaIcon {
  line-height: 24px;
}
.bylaName {
  padding-left: 5px;
  white-space: normal;
  line-height: 24px;
  max-width: 150px;
}
.bylaNameLine {
  white-space: nowrap;
}
.noIcon {
  padding-left: 0px;
}
.bylaNameLong {
  max-width: 380px;
}
.bylaNameModal {
  max-width: 250px !important;
}
</style>
